import { css } from "@emotion/react"
import { ON_PRIMARY_CONTAEINER_COLOR, TERTIARY_COLOR, ON_TERTIARY_COLOR, TERTIARY_CONTAINER_COLOR, ON_TERTIARY_CONTAEINER_COLOR, ERROR_COLOR, ON_ERROR_COLOR } from "style"
import { MouseEventHandler, ReactNode } from "react"

type Props = {
  children?: ReactNode
  onClick?:MouseEventHandler<HTMLButtonElement>
  level?: string
}

export const Button = ({level='primary', ...props}: Props)=>{
  const colorCss = 
    level === 'primary' ? primaryColorCss 
    : level ==='tertiary' ? tertiaryColorCss
    : level ==='tertiaryContainer' ? tertiaryContainerColorCss
    : level === 'error' ? errorColor
    : primaryColorCss

  return(
    <button css={[buttonCss, colorCss]} onClick={props.onClick}>
      {props.children}
    </button>
  )
}

const primaryColorCss=css`
  background-color: black;
  color: ${ON_PRIMARY_CONTAEINER_COLOR};
`
const tertiaryColorCss=css`
  background-color: ${TERTIARY_COLOR};
  color: ${ON_TERTIARY_COLOR};
`

const tertiaryContainerColorCss=css`
  background-color: ${TERTIARY_CONTAINER_COLOR};
  color: ${ON_TERTIARY_CONTAEINER_COLOR};
`

const errorColor = css`
  background-color: ${ERROR_COLOR};
  color: ${ON_ERROR_COLOR};
`

const buttonCss = css`
  border: 0;
  font-size: 15px;
  padding: 10px 15px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`